import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { Card, CardBody, CardHeader } from 'reactstrap'
import Loader from './Loader'

const AlertTrendChartTalkpool = ({alertTrend, loading}) => {
  const chartOptions = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    colors: ['#2196F3', '#FF6B9D', '#9C88FF', '#ffc800'],
    dataLabels: {
      enabled: true,
      // enabledOnSeries: [0],
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 4,
        borderWidth: 0,
        opacity: 1,
        dropShadow: {
          enabled: false
        }
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#2196F3']
      },
      // offsetY:0
    },
    stroke: {
      curve: 'smooth',
      width: [3, 2, 2, 2]
    },
    grid: {
      borderColor: '#f0f0f0',
      strokeDashArray: 3
    },
    xaxis: {
      // categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      categories: alertTrend?.labels?.length > 0 ? alertTrend?.labels : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        style: {
          colors: '#999',
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      min: 0,
      // max: 2500,
      tickAmount: 5,
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        style: {
          colors: '#999',
          fontSize: '12px'
        }
      }
    },
    markers: {
      size: [8, 0, 0],
      colors: ['#2196F3'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 10
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      theme: 'light',
      style: {
        fontSize: '12px'
      }
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
      fontSize: '12px',
      fontFamily: 'inherit',
      fontWeight: 400,
      labels: {
        colors: '#999',
        useSeriesColors: false
      },
      markers: {
        width: 22,
        height: 22,
        strokeWidth: 0,
        strokeColor: '#000',
        fillColors: undefined,
        radius: 12,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 0,
        offsetY: 0
      },
      itemMargin: {
        horizontal: 20,
        vertical: 20
      }
    }
  }

  const chartSeries = [
    {
      name: 'Un Authorized Access',
      data: [61, 675, 365, 722, 1625, 884, 57]
    },
    {
      name: 'Work Permits',
      data: [400, 800, 650, 700, 1100, 600, 450]
    },
    {
      name: 'PPE Compliance',
      data: [380, 750, 600, 650, 1050, 550, 400]
    },
    {
      name: 'Intruder Detected',
      data: [200, 550, 400, 450, 1150, 510, 300]
    }
  ]

  return (
    <Card className="">
      <CardHeader className="pb-0">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h5  style={{color:'#1d67aa'}} className="mb-1 d-flex align-items-center">
              <i className="fa fa-line-chart me-2"></i>
              Alerts Trend
            </h5>
            <p className="text-muted mb-0">Real-time monitoring across all tower zones</p>
          </div>
          {/* <button className="btn btn-outline-secondary btn-sm d-flex align-items-center">
            <i className="fa fa-filter me-1"></i>
            Filter
          </button> */}
        </div>
      </CardHeader>
      <CardBody>
        <div style={{ width: '100%', height: '340px' }}>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '380px' }}>
              <Loader size="lg" />
            </div>
          ) : alertTrend?.datasets?.length > 0 ? (
            <ReactApexChart
              options={chartOptions}
              series={alertTrend?.datasets}
              type="line"
              height={360}
            />
          ) : (
            <div>No data to show</div>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default AlertTrendChartTalkpool
